angular.module('aprima-patient-api').factory('PatientSettingsService',
    ['PatientSettingsRepository', 'CurrentUser', '$q', '_', 'GuidList',
        function (PatientSettingsRepository, CurrentUser, $q, _, GuidList) {
            'use strict';

            var loadPatientFeatures = function () {

                var userId = CurrentUser.get().userId,
                    featureList;

                return PatientSettingsRepository
                    .patientFeatures(userId)
                    .then(function (data) {
                        featureList = data.PatientFeatures;

                        var featureListIndexed = {
                            'ViewClinicalSummary': _.find(featureList, {Id: GuidList.FeatureList.ViewClinicalSummary}),
                            'ViewDocuments': _.find(featureList, {Id: GuidList.FeatureList.ViewDocuments}),
                            'ViewMedications': _.find(featureList, {Id: GuidList.FeatureList.ViewMedications}),
                            'ViewProcedures': _.find(featureList, {Id: GuidList.FeatureList.ViewProcedures}),
                            'ViewImmunizations': _.find(featureList, {Id: GuidList.FeatureList.ViewImmunizations}),
                            'ViewLabTestResults': _.find(featureList, {Id: GuidList.FeatureList.ViewLabTestResults}),
                            'ViewEducationMaterial': _.find(featureList, {Id: GuidList.FeatureList.ViewEducationMaterial}),
                            'UpdateDemographics': _.find(featureList, {Id: GuidList.FeatureList.UpdateDemographics}),
                            'UpdateInsurance': _.find(featureList, {Id: GuidList.FeatureList.UpdateInsurance}),
                            'ViewMedicationAllergies': _.find(featureList, {Id: GuidList.FeatureList.ViewMedicationAllergies}),
                            'ViewMedicalHistory': _.find(featureList, {Id: GuidList.FeatureList.ViewMedicalHistory}),
                            'RequestRxRefills': _.find(featureList, {Id: GuidList.FeatureList.RequestRxRefills}),
                            'ViewCompleteChart': _.find(featureList, {Id: GuidList.FeatureList.ViewCompleteChart}),
                            'RequestAppointments': _.find(featureList, {Id: GuidList.FeatureList.RequestAppointments}),
                            'ResetPasswordFromLogin': _.find(featureList, {Id: GuidList.FeatureList.ResetPasswordFromLogin}),
                            'ViewPatientStatement': _.find(featureList, {Id: GuidList.FeatureList.ViewPatientStatement}),
                            'SendReceiveMessages': _.find(featureList, {Id: GuidList.FeatureList.SendReceiveMessages}),
                            'ViewAppointments': _.find(featureList, {Id: GuidList.FeatureList.ViewAppointments}),
                            'CheckIn': _.find(featureList, {Id: GuidList.FeatureList.CheckIn}),
                            'ViewPatientLedger': _.find(featureList, {Id: GuidList.FeatureList.ViewPatientLedger}),
                            'RequestAssistanceFromLogin': _.find(featureList, {Id: GuidList.FeatureList.RequestAssistanceFromLogin}),
                            'MakeAPayment': _.find(featureList, {Id: GuidList.FeatureList.MakeAPayment}),
                            'AllowGenerateCCD': _.find(featureList, {Id: GuidList.FeatureList.AllowGenerateCCD}),
                            'PatientMessageAttachment' : _.find(featureList, {Id: GuidList.FeatureList.PatientMessageAttachment})
                        };

                        PatientSettingsRepository.setFeatureList(featureListIndexed);
                    });
            };

            var getPatientFeatures = function (){
                return PatientSettingsRepository.getFeatureList();
            };

            return {
                loadPatientFeatures: loadPatientFeatures,
                getPatientFeatures: getPatientFeatures
            };
        }
    ]);